const strings = {
  notFound: {
    '404PageNotFound': '404: Page not found',
  },
  notAuthorized: {
    '401NotAuthorized': '401: Not Authorized',
    '401Message': 'Redirecting you back to where you came from.',
  },
  loading: {
    loadingMessage: 'Loading. Please wait.',
    pleaseWaiteMessage: 'Please wait...',
    createAccountMessage: 'Your account is being created'
  },
  validations: {
    thisField: 'This field',
    invalid: '%{label} is invalid.',
    required: '%{label} is required.',
    email: 'Please check that your email address is formatted correctly.',
  },
  shared: {
    emailAddress: 'Email Address',
    workEmailAddress: 'Work Email',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    mobilePhone: 'Mobile Phone',
    confirmPassword: 'Confirm password',
    supportProposalLabel: 'Please contact support',
    supportProposalMessage:
      'Something were wrong. Please contact support for further information.',
    supportEmailAddress: 'support@bevspot.com',
    submit: 'Submit',
    continue: 'Continue',
    food: 'Food',
    beverage: 'Beverage',
    message404: 'We are sorry but the page you requested was not found',
    processing: 'Processing',
    processingMessage: 'Just one sec.'
  },
  auth: {
    mobilePhonePlaceholder: 'Mobile Number',
    mobilePhoneDisclaimer: 'Please use a valid mobile phone number. A verification code will be sent via text.',
    agreeToTermsPartial: 'By submitting this form you agree to BevSpot\'s ',
    forgotPassword: 'Forgot your Password?',
    resetPasswordRequiredLabel: 'Please reset your password',
    forgotPasswordMessage:
      'Enter your phone number below ' +
      'and we will send you a code to reset your password.',
    forgotPasswordByEmail: 'Please enter your email',
    forgotPasswordByEmailMessage:
      'Enter your email address below ' +
      'and we will send you a code to reset your password.',
    resetPasswordLabel: 'Enter your verification code',
    resetPasswordByPhoneMessage:
      'Please check your phone for code and enter it on the box below to continue.',
    resetPasswordByEmailMessage: 'Please check your inbox for code and enter it on the box below to continue.',
    login: 'Login',
    logInTwoWords: 'Log In',
    getStarted: 'Get Started',
    phoneNumber: 'Phone Number',
    verificationCode: 'Verification code',
    confirmPhoneLabel: 'Confirm your phone number',
    confirmPhoneMessage:
      'Enter your phone number below ' +
      'and we will send you a code to confirm your phone',
    confirmPhoneCodeLabel: 'Enter your verification code',
    confirmPhoneCodeMessage:
      'Please check your phone for code and enter it on the box below to continue',
    startTrial: 'Start Trial',
    resetMyPassword: 'Reset My password',
    createYourAccount: 'Create your account',
    invitedToJoinEstablishment:
      'You have been invited to join {{name}}. In order to join, please finish creating your account.',
    termsLabel: 'Terms.'
  },
  retailerForm: {
    createRetailerFormLabel: 'Add your business',
    createRetailerFormMessage: 'Choose the account type you’d like to start with:',
    establishmentHelperMessage: 'Search for your establishment'
  },
  hubspotWidget: {
    defaultCreateHeaderText: 'Try BevSpot Food & Beverage for free',
    defaultCreateSubText:
      'No credit card required. Get started in less than 5 minutes.',
    defaultLoginHeaderText: 'Already have an account?',
    defaultLoginSubText:
      'Sign in to your personal account or Bar & Restaurant Dashboard here.',
    defaultLoggedInText: 'Welcome back, looks like you are logged in. Follow this link to your dashboard.',
    myAccount: 'My Account',
    userSettings: 'User Settings',
    scheduleChat: 'Schedule a chat',
    startFreeTrial: 'Start free trial',
    login: 'Log In',
    logout: 'Log Out',
    signUp: 'Sign Up'
  },
  address: {
    establishmentName: 'Establishment name',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    country: 'Country',
    city: 'City',
    state: 'State/Province',
    zipCode: 'Zip Code',
  },
  challengeFields: {
    family_name: 'Last Name',
    given_name: 'First Name',
    phone_number: 'Phone Number',
    mfaCode: 'SMS Code',
  },
  errors: {
    generic:
      'Something went wrong. Please contact customer support: support@bevspot.com',
    // These strings will handle error states returned from Cognito
    // See https://aws-amplify.github.io/docs/js/authentication for details
    // TODO: Update copy
    SMS_MFA: 'You need to input your SMS code.',
    SOFTWARE_TOKEN_MFA: 'Input your one-time password.',
    NEW_PASSWORD_REQUIRED: 'You need to reset your temporary password.',
    MFA_SETUP: 'Generate your passwords(?)',
    // eslint-disable-next-line max-len
    emailInUseException: 'This email is already in use, try logging in. If you think this is an error, reach out to support@bevspot.com',
    // eslint-disable-next-line max-len
    phoneNumberInUseException: 'This phone number is already in use, try logging in. If you think this is an error, reach out to support@bevspot.com',
    // eslint-disable-next-line max-len
    userNotFoundException: 'The email address or phone number that you\'ve entered doesn\'t match any accounts. Check your entry or sign up for an account.',
    notAuthorizedException: 'The password you\'ve entered is incorrect. Please try again.',
    emailFieldError: 'Please check that your email address is formatted correctly.',
    passwordFieldError: 'Password is not strong enough.',
    phoneNumberFieldError: 'Invalid phone number.'
  },
  header: {
    help: 'Need help?',
    secondLine: 'Call us at'
  }
}

export default strings
